<template>
  <div style="margin: 10px; border: 1px solid #eee; padding: 0 10px; border-radius: 5px;">
    <div class="title"><strong>{{form.storeName}}产品预销差异分析</strong></div>
    <el-table
      border
      :data="tableData"
      v-if="form.storeId == 0 || this.radio == '年'"
      :row-class-name="rowClassFunc"
      v-loading="loading"
    >
      <template v-for="item in columnData">
        <el-table-column
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          v-if="item.label === '类型'"
        ></el-table-column>
        <el-table-column
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          align="right"
          v-else-if="item.label === '全平台'"
        ></el-table-column>
        <el-table-column
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          align="right"
          v-else
        ></el-table-column>
      </template>
    </el-table>
    <el-table :data="originData" border v-else-if="form.storeId != 0 && this.radio != '月' && this.radio != '年'">
      <el-table-column label="有预无销产品" prop="preSaleTotal"></el-table-column>
      <el-table-column label="有销无预产品" prop="saleTotal"></el-table-column>
      <el-table-column label="±30%内产品" prop="innerTotal"></el-table-column>
      <el-table-column label="±30%外产品" prop="outerTotal"></el-table-column>
      <el-table-column label="总产品" prop="allTotal"></el-table-column>
    </el-table>
    <el-table :data="originData" border v-else-if="form.storeId != 0 && this.radio != '日' && this.radio != '年'">
      <el-table-column label="有预无销产品" prop="preSaleTotal"></el-table-column>
      <el-table-column label="有销无预产品" prop="saleTotal"></el-table-column>
      <el-table-column label="±30%内产品" prop="innerTotal"></el-table-column>
      <el-table-column label="±30%外产品" prop="outerTotal"></el-table-column>
      <el-table-column label="总产品" prop="allTotal"></el-table-column>
    </el-table>
    <div class="tips">说明：上述数据所涉及产品均为常规销售产品（不含新品、库存清理）2.总产品：表示有当前应售量的产品与没有应售量但有实销的产品数量和</div>
    <!-- <div class="tips">说明：上述数据所涉及产品均为常规销售产品（不含新品、库存清理）2.总产品：表示已提报预估数量产品与未提报但实际产生了销售数据产品数量和</div> -->
  </div>
</template>

<script>
import {debounce} from '@/utils/index'
export default {
  props: ['form','radio'],
  data() {
    return {
      columnData: [],
      originData: [],
      tableData: [],
      loading: false
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init:debounce(function(){
      this.loading = true
      let data = {
        data: {
          planTime: this.form.planTime,
          storeId: this.form.storeId,
          type: this.radio == "日" ? 1 : this.radio == "月" ? 2 : 3
        }
      }
      this.$q.preSalePlan.getStorePreDiffData(data)
      .then(res=>{
        let col1 = ['有预无销产品', '有销无预产品', '±30%内产品', '±30%外产品', '总产品'];
        let col2 = ['有预无销产品', '有销无预产品', '±30%内产品', '±30%外产品', '总产品'];
        let data = res.data;
        this.originData = data;
        // 设置表头
        let columnData = [];
        data.forEach((item, index) => {
          let obj = {
            label: item.storeName,
            prop: String(index)
          };
          columnData.push(obj)
        });
        columnData.unshift({
          label: '类型',
          prop: 'type'
        })
        this.$nextTick(_=>{
          this.columnData = columnData;
        })
        // 设置tableData
        let tableData = [];
        if(this.radio == '日') {
          for(let index=0; index<5; index++) {
            let obj = {};
            obj['type'] = col1[index];
            for(let k=0; k<data.length; k++) {
              if(index == 0){
                obj[String(k)] = data[k]['preSaleTotal'];
              }else if(index == 1){
                obj[String(k)] = data[k]['saleTotal'];
              }else if(index == 2){
                obj[String(k)] = data[k]['innerTotal'];
              }else if(index == 3){
                obj[String(k)] = data[k]['outerTotal'];
              }else if(index == 4){
                obj[String(k)] = data[k]['allTotal'];
              }
            }
            tableData.push(obj)
          }
        }else if(this.radio == '月' || this.radio == '年') {
          for(let index=0; index<5; index++) {
          let obj = {};
          obj['type'] = col2[index];
          for(let k=0; k<data.length; k++) {
            if(index == 0){
              obj[String(k)] = data[k]['preSaleTotal'];
            }else if(index == 1){
              obj[String(k)] = data[k]['saleTotal'];
            }else if(index == 2){
              obj[String(k)] = data[k]['innerTotal'];
            }else if(index == 3){
              obj[String(k)] = data[k]['outerTotal'];
            }else if(index == 4){
              obj[String(k)] = data[k]['allTotal'];
            }
          }
          tableData.push(obj)
        }
        }
        // console.log(tableData);
        this.tableData = tableData;
      }).finally(_=>{
        this.loading = false
      })
    },500),
    rowClassFunc({row, rowIndex}) {
      if(row.type == '总产品') {
        return 'high-light'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .title
    font-size 16px
    color #444
    margin 10px 0
  .tips
    color #777
    margin 10px 0
  >>>.high-light
    td
      color #FF3300
    td:first-child
      color #606266
</style>